import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatarTag from 'ui-addon-avatars/UIAvatarTag';
import { LOGO_URL, RESIZED_LOGO_URL } from '../constants/BusinessUnit';
import { getBusinessUnitDisplayName } from '../utils/String';
import withDeferredRender from './withDeferredRender';
import { jsx as _jsx } from "react/jsx-runtime";
const Avatar = ({
  buLogo,
  truncateLength,
  onlyLogo,
  displayName
}) => /*#__PURE__*/_jsx(UIAvatar, {
  "data-test-id": "business-unit-tag",
  type: "contact",
  src: buLogo,
  truncateLength: truncateLength,
  children: !onlyLogo && displayName
});
const AvatarTag = ({
  buLogo,
  displayName
}) => /*#__PURE__*/_jsx(UIAvatarTag, {
  "data-test-id": "business-unit-tag",
  type: "contact",
  displayName: displayName,
  src: buLogo
});
const DefaultProps = {
  noBorder: false,
  onlyLogo: false,
  deferRender: false,
  numFramesToDefer: 2
};
const BusinessUnitTag = ({
  buId,
  buOptions,
  noBorder,
  onlyLogo,
  truncateLength,
  deferRender,
  numFramesToDefer
}) => {
  const currentBusinessUnit = (buOptions || []).find(({
    id
  }) => id === buId);
  if (!currentBusinessUnit) {
    console.warn('No valid business unit selected', {
      buId,
      buOptions
    });
    return null;
  }
  let buLogo = currentBusinessUnit[RESIZED_LOGO_URL];
  if (!buLogo) {
    buLogo = currentBusinessUnit[LOGO_URL];
  }
  const displayName = getBusinessUnitDisplayName(currentBusinessUnit.name, currentBusinessUnit.id);
  if (noBorder || onlyLogo) {
    if (buLogo) {
      let AvatarComp = Avatar;
      if (deferRender) {
        AvatarComp = withDeferredRender(Avatar, {
          Skeleton: () => /*#__PURE__*/_jsx(UIAvatar, {
            "data-test-id": "business-unit-tag",
            type: "contact",
            children: !onlyLogo && displayName
          })
        });
      }
      return /*#__PURE__*/_jsx(AvatarComp, {
        buLogo: buLogo,
        truncateLength: truncateLength,
        onlyLogo: onlyLogo,
        displayName: displayName,
        numFramesToDefer: numFramesToDefer
      });
    }
    return /*#__PURE__*/_jsx(UIAvatar, {
      "data-test-id": "business-unit-tag",
      type: "contact",
      displayName: displayName,
      truncateLength: truncateLength,
      children: !onlyLogo && displayName
    });
  }
  if (buLogo) {
    let AvatarTagComp = AvatarTag;
    if (deferRender) {
      AvatarTagComp = withDeferredRender(AvatarTag, {
        Skeleton: () => /*#__PURE__*/_jsx(UIAvatarTag, {
          "data-test-id": "business-unit-tag",
          type: "contact",
          displayName: displayName
        })
      });
    }
    return /*#__PURE__*/_jsx(AvatarTagComp, {
      displayName: displayName,
      buLogo: buLogo,
      numFramesToDefer: numFramesToDefer
    });
  }
  return /*#__PURE__*/_jsx(UIAvatarTag, {
    "data-test-id": "business-unit-tag",
    type: "contact",
    displayName: displayName
  });
};
BusinessUnitTag.propTypes = {
  buOptions: PropTypes.array.isRequired,
  buId: PropTypes.number.isRequired,
  noBorder: PropTypes.bool,
  onlyLogo: PropTypes.bool,
  truncateLength: PropTypes.number,
  deferRender: PropTypes.bool,
  numFramesToDefer: PropTypes.number
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
BusinessUnitTag.defaultProps = DefaultProps;
export default BusinessUnitTag;